// extracted by mini-css-extract-plugin
export default {"paginationField":"kVqAoGxKAdNk093iEO8X"};